
import axios from './axios';

export const getSubOrderStatuses = ({ params } = {}) => axios.get(`sub_order_statuses`, { params });
